import { createRoot } from 'react-dom/client'
import { Provider } from '../reactquery'
import { getShadowRootNode } from '../../../utils/dom'

export function openModal(Component, props = {}, client) {
  let appendedElem = null
  const shadowRootNode = getShadowRootNode()
  const modalContainer = document.createElement('div')
  modalContainer.setAttribute('id', 'modal-root')

  if (appendedElem) {
    shadowRootNode.removeChild(appendedElem)
  }

  appendedElem = modalContainer
  const modalRoot = createRoot(shadowRootNode.appendChild(appendedElem))

  modalRoot.render(
    <Provider client={client}>
      <Component {...props} />
    </Provider>
  )
}
